export default __webpack_public_path__ + "static/media/AssortmentColumnSelection.85c3f80c.png";